import React from "react";
import LoginComponent from "../components/LoginComponent";

const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3005';
console.log('Base URL:', baseUrl);

export default function Loginpage() {
  const handleLogin = async ({ email, password }) => {

    //Miramos si tiene token
    const token = localStorage.getItem('token');
    console.log('Existing token:', token);
    if (token) {
      alert('Ya estás logueado');
      window.location.href = '/profile';
      return;
    }

    const body = {
      email: email,
      password: password
    };
    console.log("Login Body:", body);


    try {
      const response = await fetch(`${baseUrl}/users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();
      console.log('Response data:', data);

      if (!response.ok) {
        alert(data.message || 'Error al iniciar sesión');
        return false;
      }

      // Login exitoso
      //Nos guardamos el token en localStorage
      localStorage.setItem('token', data.token);
      let user = data.user;
      console.log('User data:', user);
      const isAdmin = Boolean(
        user?.admin ?? user?.isAdmin ?? data?.admin ?? data?.isAdmin
      );
      localStorage.setItem('userId', user.id);
      localStorage.setItem('name', user.name);
      localStorage.setItem('email', user.email);
      // Nombre y apellidos alimentan las iniciales del avatar por defecto
      localStorage.setItem('profileName', user.name || '');
      localStorage.setItem('profileSurname', user.surname || '');
      localStorage.setItem('profileImage', user.profilePicture || '');
      localStorage.setItem('isAdmin', String(isAdmin));

      window.location.href = '/home';
      return true;

    } catch (error) {
      console.error('Error en la petición:', error);
      alert('Error de conexión con el servidor');
      return false;
    }
  };

  return React.createElement(LoginComponent, { loginUser: handleLogin });
}
